<div data-ng-include="'blocks/conference_logo.html'"></div>

<div class="wrapper-lg">
    <div class="padder-lg">
        <div data-ng-include="'blocks/conference_nav.html'"></div>
        <div ng-include="form_template"></div>
    </div>
</div>